module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dialog', {
    staticClass: "img",
    attrs: {
      "visible": _vm.isShowImageDialog,
      "title": "图片查看"
    },
    on: {
      "update:visible": function($event) {
        _vm.isShowImageDialog = $event
      },
      "closed": _vm.clearImg
    }
  }, [_c('el-carousel', {
    attrs: {
      "indicator-position": "outside",
      "min-height": "300",
      "arrow": _vm.spanshow
    }
  }, _vm._l((_vm.imgs), function(src, index) {
    return _c('el-carousel-item', {
      key: index
    }, [_c('img', {
      staticStyle: {
        "max-width": "100%",
        "height": "300px",
        "display": "block",
        "margin": "0 auto"
      },
      attrs: {
        "src": src
      }
    })])
  }), 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-4f8cadfe!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/imgPreview/ImgPreview.vue
// module id = 1686
// module chunks = 3